import React from 'react';
import { ShieldAlert } from 'lucide-react';
export function DisclaimerSection() {
  return <section className="py-16 bg-white" data-id="element-85">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-86">
        <div className="border-l-4 border-[#0A5E5C] bg-gray-50 rounded-r-xl p-8 md:p-10" data-id="element-87">
          <div className="flex items-center gap-3 mb-6" data-id="element-88">
            <ShieldAlert className="w-7 h-7 text-[#0A5E5C] flex-shrink-0" data-id="element-89" />
            <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-90">
              Important Information
            </h3>
          </div>

          <p className="text-gray-700 leading-relaxed mb-5" data-id="element-91">
            Fair Gaming Space is an independent non-governmental organization
            and:
          </p>

          <ul className="space-y-3 mb-6" data-id="element-92">
            <li className="flex items-start gap-3 text-gray-700" data-id="element-93">
              <span className="text-[#D4A843] font-bold mt-0.5" data-id="element-94">•</span>
              is not a gambling operator
            </li>
            <li className="flex items-start gap-3 text-gray-700" data-id="element-95">
              <span className="text-[#D4A843] font-bold mt-0.5" data-id="element-96">•</span>
              does not conduct gambling activities
            </li>
            <li className="flex items-start gap-3 text-gray-700" data-id="element-97">
              <span className="text-[#D4A843] font-bold mt-0.5" data-id="element-98">•</span>
              does not receive remuneration from operators for promoting their
              services
            </li>
            <li className="flex items-start gap-3 text-gray-700" data-id="element-99">
              <span className="text-[#D4A843] font-bold mt-0.5" data-id="element-100">•</span>
              does not engage in affiliate activities
            </li>
          </ul>

          <p className="text-gray-700 leading-relaxed" data-id="element-101">
            No information on this website is or can be considered as in any way
            encouraging gambling or promoting gambling activities.
          </p>
        </div>
      </div>
    </section>;
}